import { useLang } from "@/lib/i18n";

export const LangToggle = ({ dark = false }) => {
  const { lang, setLang } = useLang();
  const base = "px-3 py-1.5 text-xs font-semibold rounded-full";
  const on = dark ? "bg-white text-navy" : "bg-navy text-white";
  const off = dark ? "text-white/80 hover:text-white" : "text-navy/70 hover:text-navy";
  return (
    <div role="group" aria-label="Language" className={`flex items-center rounded-full p-0.5 ${dark ? "bg-white/10" : "bg-navy/5"}`}>
      <button data-testid="lang-toggle-hi" aria-pressed={lang === "hi"} onClick={() => setLang("hi")} className={`${base} font-hi ${lang === "hi" ? on : off}`} style={{ transition: "background-color .2s, color .2s" }}>हिं</button>
      <button data-testid="lang-toggle-en" aria-pressed={lang === "en"} onClick={() => setLang("en")} className={`${base} ${lang === "en" ? on : off}`} style={{ transition: "background-color .2s, color .2s" }}>EN</button>
    </div>
  );
};
